var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"continer"},[_c('div',{staticClass:"center"},[_c('span',[_vm._v("0475-6336566")]),_c('span',[_vm._v("内蒙通辽欢迎您!")])])])}]

export { render, staticRenderFns }